import React from "react"

import { getMapTypeValueFromState } from "@/redux/user-preferences.reducer"
import { useRootSelector } from "@/redux/useRootSelector"
import { GoogleMap as GoogleMapBase } from "@react-google-maps/api"

import type { GoogleMapProps } from "@react-google-maps/api"

const GoogleMap = React.forwardRef<GoogleMapBase, GoogleMapProps>(
  function GoogleMap(
    { mapContainerStyle, options, zoom = 13, ...props },
    ref,
  ) {
    const mapTypeId = useRootSelector(getMapTypeValueFromState)

    const optionsMemo = React.useMemo((): google.maps.MapOptions => {
      return {
        mapTypeId,
        zoom,
        ...options,
      }
    }, [mapTypeId, options, zoom])
    const style = React.useMemo((): GoogleMapProps["mapContainerStyle"] => {
      return {
        flex: 1,
        ...mapContainerStyle,
      }
    }, [mapContainerStyle])
    return (
      <GoogleMapBase
        ref={ref}
        mapContainerStyle={style}
        options={optionsMemo}
        {...props}
      />
    )
  },
)

export default GoogleMap
